import { loadState, saveState } from '../localStorage'
import { hosts } from './hosts'

const initialExampleMap = { 'rules': [[]], 'questions': [], 'notes': { text: '' } }

export default class StandaloneAdapter {
  async load () {
    let state = loadState()
    if (typeof state === 'undefined') {
      state = initialExampleMap
    }
    return state
  }

  async save (state) {
    saveState(state)
  }

  async fetchSummary () {
    return 'Get the full, Jira integrated version at https://tinyurl.com/EMforJira'
  }

  async fetchIssueKey () {
    return 'Demo Mode'
  }

  async getCustomerIdentifier () {
    return 'website'
  }

  getHost () {
    return hosts.STANDALONE
  }

  async loadInitialExampleMap () {
    return initialExampleMap
  }
}
